import { views } from '@/v-shop/autoloader'

export default () => [
	{
		path: `/recetadigital`,
		name: 'recetadigital',
		component: views.RecetaDigital,
	},
]

